import React from 'react';

const NebulaMetadataFormModal = React.lazy(() => import('../components/FormModal'));
const nebulaMetadataModalRegistry = {
    personalize_nebulaMetadataId: NebulaMetadataFormModal
};
export default nebulaMetadataModalRegistry;
